type IStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
class TokenStorage implements IStorage {
  private datastore: Record<string, string> = {};

  public constructor() {}

  public getItem(key: string): string | null {
    const item = this.datastore[key];
    if (typeof item !== 'string') {
      return null;
    }
    return item;
  }

  public setItem(key: string, value: string): string {
    this.datastore[key] = value;
    return key;
  }

  public removeItem(key: string): void {
    if (key in this.datastore) {
      delete this.datastore[key];
    }
  }
}

/** Object to act as a datastore for storing access tokens in-memory. More secure than Cookies and achieves same effect */
const tokenStorage = new TokenStorage();
export { tokenStorage };
